module.exports = __webpack_public_path__ + "assets/img/preview_03.6ae97db8.png";